import React, { Component } from "react";
import cookie from "react-cookies";

class Logout extends Component {
  constructor(props) {
    super(props);
    var LoginType = this.props.match?.params?.LoginType ?? ''
    this.state = {
      loginType: LoginType,
    };
  }
  componentWillMount() {
    cookie.remove("loginName", { path: "/" });
    cookie.remove("accessToken", { path: "/" });
    cookie.remove("loginID", { path: "/" });
    this.props.history.push("/");
  }
  render() {
    return <h1 className="loading-text">Logging out...</h1>;
  }
}

export default Logout;
